import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import calendarEvents from '../../data/calendarEvents.json'
import moment from 'moment';
import axios from 'axios';
import '../../styles/calendar.css';

import _each from 'lodash/each';
import _filter from 'lodash/filter';

import urlHelper from '../../utils/urlHelper';
import commonFunctions from '../../utils/commonFunctions';
import asyncRequest from '../../utils/asyncRequest';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    loader: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        zIndex: '9999',
    },
}));

function Calendar() {

    const [employeeId] = useState(commonFunctions.getUserEmployeeId());
    const biddingYear = new Date().getFullYear() + 1;
    const [showLoader, setShowLoader] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogButtonText, setDialogButtonText] = useState('');
    const [events, setEvents] = useState([]);

    useEffect(() => {
        //go get the slots available for this year and next
        const url1 = urlHelper.getAvailableSlots(employeeId, biddingYear - 1);
        const url2 = urlHelper.getAvailableSlots(employeeId, biddingYear);

        var allEvents = [];
        //add the calendar events
        _each(calendarEvents, function(o) {
            allEvents.push(o);
        });

        //make the database call to get slots available
        axios.all([asyncRequest.get(url1), asyncRequest.get(url2)])
        .then(function(response) {
            
            //filter to get the slots only where availSlotsForDay < 1
            var slots1 = _filter(response[0].data, function(o){
                return o.availSlotsForDay < 1;
            });
            var slots2 = _filter(response[1].data, function(o){
                return o.availSlotsForDay < 1;
            });

            //add "No Slots Available" days to the calendar
            _each(slots1, function(o) {
                allEvents.push(
                    {
                        "title": "No Slots Available", 
                        "date": moment(o.slotDate).format("YYYY-MM-DD"),
                        "display" : "background",
                        "backgroundColor": "white"
                    }
                );
            });
            _each(slots2, function(o) {
                allEvents.push(
                    {
                        "title": "No Slots Available", 
                        "date": moment(o.slotDate).format("YYYY-MM-DD"),
                        "display" : "background",
                        "backgroundColor": "white"
                    }
                ); 
            });
        }).catch((error) => {
            console.log('ERROR', error);
            handleOpenDialog('Error', error.message, 'Ok');
            setShowLoader(false);
        }).then(() => {
            setEvents(allEvents);
            setShowLoader(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleOpenDialog = (title, message, buttonText) => {
        setDialogTitle(title);
        setDialogMessage(message);
        setDialogButtonText(buttonText);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setDialogTitle('');
        setDialogMessage('');
        setDialogButtonText('');
        setOpenDialog(false);
    };

    const classes = useStyles();

    return (
        <>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                events={events}
            />
            <Dialog
                open={openDialog}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>{dialogTitle}</DialogTitle>
                {dialogMessage !== '' &&
                <DialogContent dividers>
                    <Typography gutterBottom>
                        {dialogMessage}
                    </Typography>
                </DialogContent>}
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary" autoFocus>
                        {dialogButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
            {showLoader && <CircularProgress className={classes.loader} />}
        </>
    )
}

export default Calendar;